import React from "react";
import { Dropdown } from "semantic-ui-react";

const LanguageSelector = ({ language, languageOptions, setLanguage }) => {
  return (
    <Dropdown
      selection
      placeholder="select language"
      options={languageOptions.map(language => {
        return {
          key: language.value,
          value: language.value,
          text: language.display
        };
      })}
      value={language}
      onChange={(e, data) => setLanguage(data.value)}
    />
  );
};
export default LanguageSelector;



// WEBPACK FOOTER //
// ./src/pages/Contents/New/LanguageSelector.js